var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:{ 'image-placeholder': ! _vm.hasBaseImage(_vm.item.product) },attrs:{"src":_vm.getImage(_vm.item),"alt":"product image"},on:{"error":_vm.handleImageError}})
}
var staticRenderFns = []

export { render, staticRenderFns }